import React, { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router';

import SearchBar from 'main/components/SearchBar';
import AuthButton from 'pages/layout/components/AuthButton';
import { MenuContextProvider } from 'pages/layout/components/MenuContext';
import MenuItem from 'pages/layout/components/MenuItem';
import { getRouteInfoByLink, menuRoutes } from 'pages/layout/components/MenuList/routes';

import useStyles from './styles';

interface Props {
    adaptive?: boolean;
    showSearchBar?: boolean;
    className?: string;
    onMenuItemClick?: () => void;
}

const MenuList: React.FC<Props> = ({ className, showSearchBar, adaptive = true, onMenuItemClick }) => {
    const { classes, cx } = useStyles();
    const location = useLocation();

    const contextValue = useMemo(() => {
        const { active, expanded } = getRouteInfoByLink(location.pathname);
        return { adaptive, active, expanded };
    }, [adaptive, location.pathname]);

    const renderRoutes = useCallback(
        (routes) =>
            routes
                .filter(({ virtual }) => !virtual)
                .map(({ key, link, text, icon, children = [] }) => (
                    <MenuItem key={key} itemKey={key} link={link} text={text} icon={icon} onClick={onMenuItemClick}>
                        {renderRoutes(children)}
                    </MenuItem>
                )),
        [onMenuItemClick]
    );

    return (
        <MenuContextProvider value={contextValue}>
            <div className={cx(classes.container, className)}>
                {showSearchBar && <SearchBar compact className={classes.searchBarRoot} />}
                <div className={classes.wrapper}>
                    <div className={cx(classes.menuList, { [classes.menuListAdaptive]: adaptive })}>
                        {renderRoutes(menuRoutes)}
                    </div>
                </div>
                <AuthButton className={cx(classes.authButton, { [classes.authButtonAdaptive]: adaptive })} />
            </div>
        </MenuContextProvider>
    );
};

export default MenuList;
